/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * updated at 2021-12-30 10:58:12
 * */

export default {
  /** 是否显示分隔线 */
  divider: {
    type: Boolean,
    default: true,
  },
  /** 分组别名 */
  label: {
    type: String,
    default: '',
  },
};
